import {createReducer} from "typesafe-actions";
import update from "immutability-helper";
import {gotAesJson, gotAesSignatures} from "../actions/signatures";
import {AesSignatureState} from "../types/pdfSignatures";

const initialState: AesSignatureState = {
    total: 0,
};

export const aesSignaturesReducer = createReducer(initialState)
    .handleAction(gotAesSignatures, (state, action) => update(state, {
        signatures: {$set: action.payload.items},
        total: {$set: action.payload.total},
    }))
    .handleAction(gotAesJson, (state, action) => update(state, {
        json: {$set: action.payload},
    }))
;
